import { ApiUrlEnum } from 'src/config/endPointsConfig';
import { get, patch } from 'src/utils/axios';
import { pathToUrl } from 'src/utils/path-to-url';

export async function getImpacts(params: { program?: string; volet?: string }) {
  const response: any = await get(pathToUrl(ApiUrlEnum.impact), {
    queryParams: { ...params },
  });

  return {
    results: response.data.result,
  };
}

export async function getProgramXVolet() {
  const response: any = await get(pathToUrl(ApiUrlEnum.programxvolet));
  return {
    results: response.data,
  };
}

export async function editMetric({
  id,
  nb,
  nbV,
  title,
  titleV,
  snte,
  ciblep,
  startv,
  contribSnte,
  contribSntev,
  ciblev,
  values,
  nbExtra,
  voletv,
  voletp,
  nbExtraV,
  indicProg,
  indicProgV,
  source,
  sourceV,
}: {
  id: string;
  nb?: string;
  nbV?: string;
  title?: string;
  titleV?: string;
  contribSnte?: string;
  voletv?: string;
  voletp?: string;
  contribSntev?: string;
  snte?: string | any;
  startv?: string;
  ciblev?: string;
  ciblep?: string;
  nbExtra?: string;
  nbExtraV?: string;
  indicProgV?: string;
  indicProg?: string;
  sourceV?: string;
  source?: string;
  values?: { key: string; value: string }[];
}): Promise<void> {
  await patch(pathToUrl(ApiUrlEnum.metric, { id }), {
    body: {
      ...(title && { title }),
      ...(titleV && { titleV }),
      ...(nb && { nb }),
      ...(nbV && { nbV }),
      ...(values && { values }),
      ...(snte && { snte }),
      ...(startv && { startv }),
      ...(ciblev && { ciblev }),
      ...(nbExtra && { nbExtra }),
      ...(nbExtraV && { nbExtraV }),
      ...(indicProgV && { indicProgV }),
      ...(indicProg && { indicProg }),
      ...(sourceV && { sourceV }),
      ...(ciblep && { ciblep }),
      ...(source && { source }),
      ...(contribSnte && { contribSnte }),
      ...(contribSntev && { contribSntev }),
      ...(voletv && { voletv }),
      ...(voletp && { voletp }),
    },
  });
}

export async function editImpact({ id, comment }: { id: string; comment: string }): Promise<void> {
  await patch(pathToUrl(ApiUrlEnum.editimpact, { id }), {
    body: {
      comment,
    },
  });
}

export async function editProduct({ id, comment }: { id: string; comment: string }): Promise<void> {
  await patch(pathToUrl(ApiUrlEnum.editproduct, { id }), {
    body: {
      comment,
    },
  });
}

export async function editEffect({ id, comment }: { id: string; comment: string }): Promise<void> {
  await patch(pathToUrl(ApiUrlEnum.editEffect, { id }), {
    body: {
      comment,
    },
  });
}
